import React, { useState, useEffect, useRef } from "react";
import { Button, FormGroup, Row, Col, Label, Form, Modal, ModalHeader, ModalBody, ModalFooter, Input, CustomInput, FormFeedback } from 'reactstrap';
import { Trans } from "react-i18next";
import { SketchPicker } from "react-color";
import Dropzone from "react-dropzone";
import { PendingButton } from "components/common";
import InvoicePreviewContainer from "./InvoicePreviewContainer";

const defaultSettings = {
  layout: '',
  is_default: false,
  font_size: 16,
  font_family: '',
  font_color: '#000000',
  invoice_logo_style: { is_visible: true, alignment: 'left', width: '', height: '', margin: { top: 0, right: 0, bottom: 0, left: 0 } },
  header_logo_style: { is_visible: true, width: '', height: '', },
  footer_logo_style: { is_visible: true, width: '', height: '170', },
  invoice_title_style: { color: '#000000', font_weight: 'normal', font_size: 16 },
  invoice_label_style: { color: '#000000', font_weight: 'normal', font_size: 16 },
  invoice_content_style: { color: '#000000', font_weight: 'normal', font_size: 16 },
  line_item_header_style: { color: '#000000', font_weight: 'normal', font_size: 16 },
  line_item_style: { color: '#000000', font_weight: 'normal', font_size: 16 },
  subtotal_line_style: { color: '#000000', font_weight: 'normal', font_size: 16 },
  tax_line_style: { color: '#000000', font_weight: 'normal', font_size: 16 },
  total_line_style: { color: '#000000', font_weight: 'normal', font_size: 16 },
}

const InvoiceLayoutSettingsModal = (props) => {
  const { modal, toggle, index, t, submitHandler, data, size, fullscreen, className, centered, scrollable, settings, } = props



  const [formData, setFormData] = useState({});

  const [validationErrors, setValidationErrors] = useState({});
  const colorPickerRef = useRef({});

  const [colorPickerVisibility, setColorPickerVisibility] = useState({
    invoice_title_style: false,
    invoice_label_style: false,
    invoice_content_style: false,
    line_item_header_style: false,
    line_item_style: false,
    subtotal_line_style: false,
    tax_line_style: false,
    total_line_style: false,
  });

  const onSubmit = () => {
    if (!validateForm()) {
      return;
    }

    submitHandler(formData, index)

    // toggle()
  }

  useEffect(() => {
    if (data) {
      if (data.header_logo_style?.is_visible === undefined) {
        data.header_logo_style.is_visible = true
      }

      if (data.invoice_logo_style?.is_visible === undefined) {
        data.invoice_logo_style.is_visible = true
      }

      if (data.footer_logo_style?.is_visible === undefined) {
        data.footer_logo_style.is_visible = true
      }

      setFormData(data)
    } else {
      setFormData(defaultSettings)
    }
  }, [modal]);

  const INVOICE_ELEMENTS = [
    'invoice_title_style',
    'invoice_label_style',
    'invoice_content_style',
    'line_item_header_style',
    'line_item_style',
    'subtotal_line_style',
    'tax_line_style',
    'total_line_style',
  ]

  const LIST_OF_LAYOUTS = [
    { value: 'default', label: 'Default Layout' },
    { value: 'layout_one', label: 'Layout One' },
    { value: 'layout_two', label: 'Layout Two' },
    // { value: 'layout_three', label: 'Layout Three' }, 
    // { value: 'layout_four', label: 'Layout Four' }
  ]

  const LIST_OF_FONT_FAMILIES = [
    { value: 'Source Sans Pro', label: 'Source Sans Pro' },
    { value: 'Sakkal Majalla', label: 'Sakkal Majalla' },
    { value: 'Tajawal', label: 'Tajawal' },
    { value: 'Arial', label: 'Arial' },

  ]

  const toggleColorPicker = (field) => {
    setColorPickerVisibility({
      [field]: !colorPickerVisibility[field],
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });

    setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };

  const handleColorChange = (color, field) => {
    if (field === 'font_color') {
      setFormData({
        ...formData,
        [field]: color.hex,
      });
    } else {
      setFormData({
        ...formData,
        [field]: {
          ...formData[field],
          color: color.hex,
        },
      });
    }
  };

  const handleClickOutside = (event) => {
    const keys = Object.keys(colorPickerRef.current);
    keys.forEach((key) => {
      if (colorPickerRef.current[key] && !colorPickerRef.current[key].contains(event.target)) {
        setColorPickerVisibility((prev) => ({
          ...prev,
          [key]: false,
        }));
      }
    });
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleJsonChange = (e, field, key) => {
    const { value, type, checked } = e.target;
    setFormData({
      ...formData,
      [field]: {
        ...formData[field],
        [key]: type === 'checkbox' ? checked : value,
      },
    });

    setValidationErrors((prevErrors) => ({ ...prevErrors, [field]: { ...prevErrors[field], [key]: '' } }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.layout.trim()) {
      errors.layout = 'Layout is required';
    }
    if (formData.font_size <= 0) {
      errors.font_size = 'Font size must be a positive number';
    }
    if (!formData.font_family.trim()) {
      errors.font_family = 'Font family is required';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onDropAccepted = ([file], field) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      setFormData({
        ...formData,
        [field]: e.target.result,
      })
    };
    reader.readAsDataURL(file)
  }

  const onLogoError = (field) => {
    setFormData({
      ...formData,
      [field]: {
        invalid: true,
      }
    })
  }

  const onLogoLoad = (field) => {
    setFormData({
      ...formData,
      [field]: {
        invalid: true,
      }
    })
  }

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      size={size || 'lg'}
      centered={centered}
      scrollable={scrollable}
      className={fullscreen ? `${className} modal-fullscreen` : className}
    >
      <ModalHeader toggle={toggle}><Trans>{t('Invoice Layout Settings')}</Trans></ModalHeader>

      <ModalBody style={{ overflowY: 'visible' }}>
        <div className="row">
          <Col md={6}>
            <div className="m-4">
              <Form className="invoice-layout-settings-form">
                <div className="border p-2">
                  <Row>
                    <Col md={6}>
                      <FormGroup className="mb-3">
                        <Label htmlFor="name">{t('Template Name')}</Label>
                        <Input
                          type="text"
                          name="name"
                          id="name"
                          onChange={handleChange}
                          value={formData.name}
                          invalid={!!validationErrors.name}
                        >
                        </Input>
                        <FormFeedback>{validationErrors.name}</FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row form>
                    <Col md={6}>
                      <FormGroup className="mb-3">
                        <Label htmlFor="layout">{t('Layout')}</Label>
                        <Input
                          type="select"
                          name="layout"
                          id="layout"
                          value={formData.layout}
                          onChange={handleChange}
                          invalid={!!validationErrors.layout}
                        >
                          <option value="">{t('Select layout')}</option>
                          {
                            LIST_OF_LAYOUTS.map((layout) => (
                              <option key={layout.value} value={layout.value}>{layout.label}</option>
                            ))
                          }
                        </Input>

                        <FormFeedback>{validationErrors.layout}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="is_default">{t('Default')}</Label>
                        <CustomInput type="checkbox" id="is_default" name="is_default" checked={formData.is_default} label={t('Make as default settings')} onChange={handleChange} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row form>
                    <Col md={4}>
                      <FormGroup className="mb-3">
                        <Label htmlFor="font_size">{t('Font Size')}</Label>
                        <Input type="number" name="font_size" id="font_size" value={formData.font_size} onChange={handleChange} invalid={!!validationErrors.font_size} />
                        <FormFeedback>{validationErrors.font_size}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label htmlFor="font_family">{t('Font Family')}</Label>
                        <Input type="select" name="font_family" id="font_family" value={formData.font_family} onChange={handleChange} invalid={!!validationErrors.font_family}>
                          <option value="">{t('Select font family')}</option>
                          {LIST_OF_FONT_FAMILIES.map((font) => <option key={font.value} value={font.value}>{font.label}</option>)}
                        </Input>
                        <FormFeedback>{validationErrors.font_family}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label htmlFor="font_color">{t('Font Color')}</Label>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Input
                            type="text"
                            name="font_color"
                            id="font_color"
                            value={formData?.font_color || '#000000'}
                            onChange={handleChange}
                            invalid={!!validationErrors.font_color}
                            readOnly
                          />
                          <i
                            className="fa-2x fa fa-square"
                            style={{ cursor: 'pointer', color: formData?.font_color || '#000000', marginLeft: '-30px' }}
                            onClick={() => toggleColorPicker('font_color')}
                          />
                        </div>


                        {colorPickerVisibility['font_color'] && (
                          <div ref={(el) => (colorPickerRef.current['font_color'] = el)} style={{ position: 'absolute', zIndex: 2 }}>
                            <SketchPicker
                              color={formData?.font_color}
                              onChangeComplete={(color) => handleColorChange(color, 'font_color')}
                            />
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
                <div className="my-3 border p-2">
                  <h6>{t('Logo Style')}</h6>
                  <Row form>
                    <Col md={12} className="mb-2">
                      <FormGroup>
                        <Label htmlFor="logo">{t('Logo')}</Label>
                        <Dropzone
                          multiple={false}
                          className="border border-primary rounded"
                          style={{ backgroundColor: '#F4F7FE' }}
                          onDropAccepted={(evt) => onDropAccepted(evt, 'logo')}
                        >
                          <div className="m-2 text-center">
                            {formData.logo ? (
                              <div>
                                <img
                                  alt="logo"
                                  onLoad={onLogoLoad}
                                  onError={onLogoError}
                                  className="img-thumbnail mb-3"
                                  src={formData.logo}
                                  style={{ maxWidth: "100%" }}
                                />
                              </div>
                            ) : null}
                            <span>
                              <Trans>
                                Drop an image file here, or click to select a file to upload.
                              </Trans>
                            </span>
                          </div>
                        </Dropzone>
                        {formData.logo ? (
                          <PendingButton
                            className="mt-1"
                            onClick={() => {
                              setFormData({ ...formData, logo: null });
                            }}
                          >
                            Clear
                          </PendingButton>
                        ) : null}

                        <FormFeedback>{validationErrors.logo}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label htmlFor="invoice_logo_style_show_hide">{t('Show Logo')}</Label>
                        <CustomInput type="checkbox" name="invoice_logo_style_is_visible" id="invoice_logo_style_is_visible" checked={formData['invoice_logo_style']?.is_visible} label={t('Show logo in invoice')} onChange={(e) => handleJsonChange(e, 'invoice_logo_style', 'is_visible')} />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label htmlFor="invoice_logo_style_alignment">{t('Alignment')}</Label>
                        <Input type="select" name="invoice_logo_style_alignment" id="invoice_logo_style_alignment" value={formData['invoice_logo_style']?.alignment} onChange={(e) => handleJsonChange(e, 'invoice_logo_style', 'alignment')}>
                          <option value="">{t('Select alignment')}</option>
                          <option value="left">{t('Left')}</option>
                          <option value="center">{t('Center')}</option>
                          <option value="right">{t('Right')}</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label htmlFor="invoice_logo_style_width">{t('Width')}</Label>
                        <Input type="number" name="invoice_logo_style_width" id="invoice_logo_style_width" value={formData['invoice_logo_style']?.width} onChange={(e) => handleJsonChange(e, 'invoice_logo_style', 'width')} />
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label htmlFor="invoice_logo_style_height">{t('Height')}</Label>
                        <Input type="number" name="invoice_logo_style_height" id="invoice_logo_style_height" value={formData['invoice_logo_style']?.height} onChange={(e) => handleJsonChange(e, 'invoice_logo_style', 'height')} />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>

                <div className="my-3 border p-2">
                  <Row form>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="header-logo">{t('Header Image')}</Label>
                        <Dropzone
                          multiple={false}
                          className="border border-primary rounded"
                          style={{ backgroundColor: '#F4F7FE' }}
                          onDropAccepted={(evt) => onDropAccepted(evt, 'header_logo')}
                        >
                          <div className="m-2 text-center">
                            {formData.header_logo ? (
                              <div>
                                <img
                                  alt="header_logo"
                                  onLoad={onLogoLoad}
                                  onError={onLogoError}
                                  className="img-thumbnail mb-3"
                                  src={formData.header_logo}
                                  style={{ maxWidth: "100%" }}
                                />
                              </div>
                            ) : null}
                            <span>
                              <Trans>
                                Drop an image file here, or click to select a file to upload.
                              </Trans>
                            </span>
                          </div>
                        </Dropzone>
                        {formData.header_logo ? (
                          <PendingButton
                            className="mt-1"
                            onClick={() => {
                              setFormData({ ...formData, header_logo: null });
                            }}
                          >
                            Clear
                          </PendingButton>
                        ) : null}

                        <FormFeedback>{validationErrors.header_logo}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label htmlFor="header_logo_style_show_hide">{t('Show Image')}</Label>
                        <CustomInput type="checkbox" name="header_logo_style_is_visible" id="header_logo_style_is_visible" checked={formData['header_logo_style']?.is_visible} label={t('Show header image')} onChange={(e) => handleJsonChange(e, 'header_logo_style', 'is_visible')} />
                      </FormGroup>
                    </Col>
                    <Col md={2}>
                      <FormGroup>
                        <Label htmlFor="header_logo_style_height">{t('Height')}</Label>
                        <Input type="number" name="header_logo_style_height" id="header_logo_style_height" value={formData['header_logo_style']?.height} onChange={(e) => handleJsonChange(e, 'header_logo_style', 'height')} />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row form className="mt-3">
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="footer-logo">{t('Footer Image')}</Label>
                        <Dropzone
                          multiple={false}
                          className="border border-primary rounded"
                          style={{ backgroundColor: '#F4F7FE' }}
                          onDropAccepted={(evt) => onDropAccepted(evt, 'footer_logo')}
                        >
                          <div className="m-2 text-center">
                            {formData.footer_logo ? (
                              <div>
                                <img
                                  alt="footer_logo"
                                  onLoad={onLogoLoad}
                                  onError={onLogoError}
                                  className="img-thumbnail mb-3"
                                  src={formData.footer_logo}
                                  style={{ maxWidth: "100%" }}
                                />
                              </div>
                            ) : null}
                            <span>
                              <Trans>
                                Drop an image file here, or click to select a file to upload.
                              </Trans>
                            </span>
                          </div>
                        </Dropzone>
                        {formData.footer_logo ? (
                          <PendingButton
                            className="mt-1"
                            onClick={() => {
                              setFormData({ ...formData, footer_logo: null });
                            }}
                          >
                            Clear
                          </PendingButton>
                        ) : null}

                        <FormFeedback>{validationErrors.footer_logo}</FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label htmlFor="footer_logo_style_show_hide">{t('Show Image')}</Label>
                        <CustomInput type="checkbox" name="footer_logo_style_is_visible" id="footer_logo_style_is_visible" checked={formData['footer_logo_style']?.is_visible} label={t('Show footer image')} onChange={(e) => handleJsonChange(e, 'footer_logo_style', 'is_visible')} />
                      </FormGroup>
                    </Col>
                    <Col md={2}>
                      <FormGroup>
                        <Label htmlFor="footer_logo_style_height">{t('Height')}</Label>
                        <Input type="number" name="footer_logo_style_height" id="footer_logo_style_height" value={formData['footer_logo_style']?.height} onChange={(e) => handleJsonChange(e, 'footer_logo_style', 'height')} />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>

                <div className="border p-2">
                  {INVOICE_ELEMENTS?.map((field) => (
                    <div key={field} className="my-3">
                      <h6>{field.replace(/_/g, ' ').toUpperCase()}</h6>
                      <Row form>
                        <Col md={4}>
                          <FormGroup>
                            <Label for={`${field}_color`}>{t('Color')}</Label>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Input
                                type="text"
                                name={`${field}_color`}
                                id={`${field}_color`}
                                value={formData[field]?.color}
                                onChange={(e) => handleJsonChange(e, field, 'color')}
                                readOnly
                              />
                              <i
                                className="fa-2x fa fa-square"
                                style={{ cursor: 'pointer', color: formData[field]?.color || '#000000', marginLeft: '-30px' }}
                                onClick={() => toggleColorPicker(field)}
                              />
                            </div>

                            {colorPickerVisibility[field] && (
                              <div ref={(el) => (colorPickerRef.current[field] = el)} style={{ position: 'absolute', zIndex: 2 }}>
                                <SketchPicker
                                  color={formData[field]?.color}
                                  onChangeComplete={(color) => handleColorChange(color, field)}
                                />
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label for={`${field}_font_size`}>{t('Font Size')}</Label>
                            <Input
                              type="number"
                              name={`${field}_font_size`}
                              id={`${field}_font_size`}
                              value={formData[field]?.font_size}
                              onChange={(e) => handleJsonChange(e, field, 'font_size')}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                            <Label for={`${field}_font_weight`}>{t('Font Weight')}</Label>
                            <Input type="select" name={`${field}_font_weight`} id={`${field}_font_weight`} value={formData[field]?.font_weight} onChange={(e) => handleJsonChange(e, field, 'font_weight')}>
                              <option value="">{t('Select font weight')}</option>
                              <option value="normal">{t('Normal')}</option>
                              <option value="bold">{t('Bold')}</option>
                              <option value="bolder">{t('Bolder')}</option>
                              <option value="lighter">{t('Lighter')}</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </div>
                <div className="border p-2 my-3">
                  <Row>
                    <Col md={12}>
                      <FormGroup className="pb-2">
                        <Label for={`header`}>{t('Header')}</Label>
                        <Input type="textarea" rows="4" name={`header`} onChange={handleChange} value={formData.header} />
                      </FormGroup>
                      <FormGroup className="pt-2 pb-2">
                        <Label for={`footer_english`}>{t('Terms & Payment Advice (English)')}</Label>
                        <Input type="textarea" rows="4" name={`footer_english`} onChange={handleChange} value={formData.footer_english} />
                      </FormGroup>
                      <FormGroup className="py-2">
                        <Label for={`footer`}>{t('Terms & Payment Advice (Arabic)')}</Label>
                        <Input type="textarea" rows="4" name={`footer`} onChange={handleChange} value={formData.footer} />
                      </FormGroup></Col>
                  </Row>
                </div>
              </Form>
            </div>
          </Col>
          <Col md={6}>
            <h4>{t('Preview')}</h4>
            <div className="m-4 invoice-preview">
              <InvoicePreviewContainer settings={settings} defaultLayoutSettings={formData} />
            </div>
          </Col>
        </div>

      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}><Trans>{t('Close')}</Trans></Button>
        <Button color="primary" onClick={onSubmit}><Trans>{t('Save')}</Trans></Button>
      </ModalFooter>
    </Modal>
  )
}

export default InvoiceLayoutSettingsModal

